import { Injectable } from '@angular/core';
import { AppSidenavItem, AppSidenavService } from 'common';
import { dashboardNavLabelForUrl, markDashboardSelection } from '../../shared/dashboard-nav.helper';

@Injectable({ providedIn: 'root' })
export class DashboardNavFacade {
  constructor(private readonly appSidenavService: AppSidenavService) {}

  /**
   * Re-marks the sidenav selection for `url` from the resolver items. Assign-only: the `AppSidenavService.items`
   * getter is self-recursive, so items are never read back from the service. `null` items leave the sidenav untouched.
   */
  select(items: AppSidenavItem[] | null, url: string): void {
    if (!items) {
      return;
    }
    this.appSidenavService.items = markDashboardSelection(items, dashboardNavLabelForUrl(url));
  }
}
